import { POST } from '@/utils/axios'

export const defaultQuery = async formData =>
  await POST('/user-details/userbase', formData, { useAuthorization: true })

export const graphDefaultQuery = async formData =>
  await POST('/user-details/userbaseGraph', formData, {
    useAuthorization: true
  })
